import {
  type Answer,
  type FAQPage,
  type Person,
  type Question,
  type SpeakableSpecification,
  type WithContext,
} from 'schema-dts'

import { type FaqItemV2 } from '@redteclab/api/clients/bully'

const getAuthorSchema = (name?: string): Person => ({
  '@type': 'Person',
  name,
})

const getAnswerSchema = (text: string, author?: string): Answer => ({
  '@type': 'Answer',
  author: getAuthorSchema(author),
  text,
})

const getFaqItemSchema = ({
  answer: answerText,
  personAnswering,
  personAsking,
  question,
}: FaqItemV2): Question => {
  const answerLayout = getAnswerSchema(
    answerText ? answerText.replaceAll(/\r\n|\n|\r/gmu, '') : '',
    personAnswering,
  )

  return {
    '@type': 'Question',
    acceptedAnswer: answerLayout,
    answerCount: 1,
    author: getAuthorSchema(personAsking),
    name: question,
    suggestedAnswer: answerLayout,
    text: question,
    upvoteCount: 0,
  }
}

const getSpeakableSchema = (
  cssSelectors: string[],
): SpeakableSpecification => ({
  '@type': 'SpeakableSpecification',
  cssSelector: cssSelectors,
})

export const jsonLdSchemasFaq = (
  faqs: FaqItemV2[],
  productName: string,
  cssSelectors: string[],
): WithContext<FAQPage> => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(getFaqItemSchema),
  name: productName,
  speakable: getSpeakableSchema(cssSelectors),
})
